import Link from 'next/link';
import styled from 'styled-components';

import { Icon } from 'antd';

import { useAtomValue } from 'jotai';
import { useImmerAtom } from 'jotai-immer';

import GFRCalculator from '../common/GFRCalculator';
import Creatinine from '../Creatinine';
import { diagnosisBaseAtom, isGFRCheckAtom, kidneyAtom } from './atom';

import { Form, Radio, Tooltip, Input, Checkbox } from 'antd';

import { useHandleEventValue } from './hooks';

// 여과율 컴포넌트
const GFRQuestion = () => {
  const { bornYear, gender } = useAtomValue(diagnosisBaseAtom);
  const { creatinineLevel } = useAtomValue(kidneyAtom);
  const isGFRCheck = useAtomValue(isGFRCheckAtom);
  const [, setKidney] = useImmerAtom(kidneyAtom);
  const handleValue = useHandleEventValue({ setImmerState: setKidney });

  if (!isGFRCheck) return null;

  return (
    <GFRQuestionWrapper>
      <GFRQueryTitle>
        정확한 영양진단을 위해
        <br />
        크레아티닌(Cr / Creatinine)
        <br />
        수치를 입력해주세요
      </GFRQueryTitle>
      <GFRDescription>
        크레아티닌 수치를 입력하면 <br />
        사구체여과율이 자동으로 계산됩니다.
        <br />
        수치를 입력하시면, 더 자세한 영양상담이 가능합니다.
        <br />
      </GFRDescription>
      <Tooltip placement="bottom" title="크레아티닌 수치는 혈액 검사를 통해 알 수 있습니다. 검사결과지에서 크레아티닌 수치를 확인하세요.">
        <span style={{ color: '#1890FF' }}>크레아티닌은 어떻게 확인하나요?</span>
      </Tooltip>
      {/* <Creatinine /> */}
      {/* <Link href="/creatinine">
        <a>
          <CreatinineButton>
            <Icon type="question-circle" style={{ marginRight: '0.5rem' }} />
            도움이 필요하세요?
          </CreatinineButton>
        </a>
      </Link> */}
      <GFRCalculator bornYear={bornYear} gender={gender} value={creatinineLevel} defaultValue={creatinineLevel} onChange={handleValue('creatinineLevel')} />
    </GFRQuestionWrapper>
  );
};

export default GFRQuestion;

const Question = styled.div`
  margin-bottom: 7rem;
  width: 100%;
  .notice {
    width: 100%;
    display: flex;
    justify-content: center;
    p {
      width: 80%;
      font-size: 1.2rem;
    }
  }

  ${props => props.theme.device.md} {
    margin-bottom: 6rem;
    .notice {
      p {
        width: 100%;

        font-size: 1.5rem;
      }
    }
  }
`;
const GFRQuestionWrapper = styled(Question)`
  ${props => props.theme.device.md} {
    margin-left: auto;
    margin-right: auto;
  }
`;

const CreatinineButton = styled.button`
  font-size: 1.4rem;
  ${props => props.theme.device.md} {
    display: none;
  }
`;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;

const GFRQueryTitle = styled(QueryTitle)`
  margin-bottom: 2.5rem;
`;

const Description = styled.div`
  word-break: keep-all;
  font-size: 1.3rem;
  color: #808080;
  margin-top: 2rem;
  ${props => props.theme.device.md} {
    font-size: 2rem;
    font-weight: 400;
  }
`;

const GFRDescription = styled(Description)`
  margin-bottom: 2.4rem;
  word-break: keep-all;
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
